import { configureStore } from "@reduxjs/toolkit";

// Reducers
import userReducer from "./reducers/userReducer";
import utilReducer from "./reducers/utilReducer";
import calendarReducer from "./reducers/calendarReducer";
import notificationReducer from "./reducers/notificationReducer";
import chatReducer from "./reducers/chatReducer";
import filterReducer from "./reducers/filterReducer";

const store = configureStore({
  reducer: {
    user: userReducer,
    utilData: utilReducer,
    calendar: calendarReducer,
    notification: notificationReducer,
    chat: chatReducer,
    filterData: filterReducer,
  },
});

export default store;
